export default "__VITE_ASSET__BCqIkfGA__"